import { render } from "./PositionForm.vue?vue&type=template&id=b82a7242"
import script from "./PositionForm.vue?vue&type=script&lang=js"
export * from "./PositionForm.vue?vue&type=script&lang=js"

import "./PositionForm.vue?vue&type=style&index=0&id=b82a7242&lang=css"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__